import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import PartnerInputs from '../../../components/admin/forms/partners/PartnerInputs';
import PartnerShow from '../../../components/admin/forms/partners/PartnerShow';
import { MODELS } from '../../../constants/admin/settings';
import { create, update, fetchMember, fetchPartnerContacts } from '../../../actions/admin/models/partners';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import AdminTable from '../AdminTable';
import { get, map, filter, capitalize } from 'lodash';
import { UserContext } from '../../../Application';
import { hasPermissions, PERMISSIONS } from '../../../constants/authentication/permissions';
import { goToContact } from '../../../actions/admin/models/contacts';
import { fetchEventsAsDependency } from '../../../actions/admin/models/events';

class Details extends Component {
    _inputData = {
        context: this.props.contextId
    };
    _transformRows = {
        functionName: (_, data) => {
            return map(
                filter(get(data, 'roles'), x => x.function),
                x => capitalize(x.function.replace(/_/g, ' '))
            ).join(', ');
        }
    };
    render() {
        return (
            <React.Fragment>
                <DetailsView
                    fetchDependencies={this.props.fetchEventsAsDependency}
                    withShowMode={!!this.props.match.params.partnerId}
                    model={MODELS.PARTNER}
                    fetchModel={this.props.fetchMember}
                    modelId={this.props.match.params.partnerId}
                    editView={PartnerInputs}
                    showView={PartnerShow}
                    updateAction={this.props.update}
                    createAction={this.props.create}
                    inputData={this._inputData}
                />
                {this.props.match.params.partnerId ? (
                    <div className="ckp-summary-table">
                        <h1 className="ckp-summary-table-title ckp-ts-h1 u-index-top ">Members</h1>
                        <UserContext.Consumer>
                            {user => (
                                <AdminTable
                                    openItem={this.props.goToContact}
                                    blockRowInteraction={() => !hasPermissions(user, PERMISSIONS.CONTACTS_VIEW)}
                                    transformFunctions={this._transformRows}
                                    fetchDataFunction={this.props.fetchPartnerContacts}
                                    disableButtonAction={true}
                                    model={MODELS.ARTIST_PARTNER_CONTACT}
                                    forceNoSelect={true}
                                    subContextId={this.props.match.params.partnerId}
                                    pagination={true}
                                />
                            )}
                        </UserContext.Consumer>
                    </div>
                ) : null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { create, update, fetchMember, fetchPartnerContacts, fetchEventsAsDependency, goToContact },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withBreadcrumb(Details, () => [BREADCRUMB.PARTNERS, BREADCRUMB.PARTNERS_FORM]));



// WEBPACK FOOTER //
// ./src/containers/admin/partners/Details.js